import {gql} from 'apollo-angular';
import {ImageFragment} from "./fragments/Image";

export const GET_INFORMATION_LINKS = gql`
  query InformationLinks($typeId: Int!) {
    informationLinks(typeID: $typeId) {
      type {
        id
        typeName
      }

      heading
      description
      linkUrl
      target
      position
      media {
        image {
          ...imageFields
        }

      }

    }
  }
  ${ImageFragment}
`;
